<template>
  <div class="admin-datatable">
    <v-card>
    <v-toolbar dark flat color="primary">
      <v-toolbar-title>Pakiety</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="!showAdd" color="accent" @click="showAdd = true" dark>dodaj pakiet</v-btn>
      <v-btn v-if="showAdd" flat small @click="showAdd = false">ukryj</v-btn>
    </v-toolbar>
    </v-card>
    <v-slide-y-transition>
    <v-card class="mt-2" v-if="showAdd">
          <package-form @success="showAdd = false; refresh()"></package-form>
    </v-card>
    </v-slide-y-transition>
    <v-card class="mt-2 pb-1">
      <v-card-title>
        <v-form class="flex">
            <v-layout row wrap justify-start>
              <v-flex xs12 sm6 md4 xl3 class="pa-1">
                <v-text-field v-model="context.searchQuery"
                  clearable
                  label="Szukaj"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 xl3 class="pa-1">
                <v-select
                  v-model="context.trainer"
                  :items="allTrainersOptions"
                  label="Trener"
                  clearable
                ></v-select>
              </v-flex>
            </v-layout>
          </v-form>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="packages"
        :pagination.sync="context"
        :rows-per-page-items="perPageOptions"
        :total-items="rowsTotal"
        :loading="loading"
      >
        <template slot="items" slot-scope="props">
          <tr>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.price}}</td>
          <td>{{ props.item.trainer_name}}</td>
          <td>{{ formatterBool(props.item.is_active)}}</td>
          <td>{{ formatterBool(props.item.with_tshirt)}}</td>
          <td>{{ formatterBool(props.item.with_card)}}</td>
          <td class="actions">
            <rp-icon
              type="edit"
              tooltip="edytuj"
              class="mr-2"
              @click="props.expanded = !props.expanded"
            />
            <rp-icon
              type="delete"
              tooltip="usuń"
              @click="deleteItem(props.item)"
            />
          </td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
            <package-form :user-package="props.item" @success="props.expanded = false; refresh()"></package-form>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {fetchPackages, deletePackage} from './api'
import {ListMixin} from '@/utils/ListMixin'
import {boolFormatter} from '@/utils/formatters'
import iziToast from 'izitoast'
import * as types from '@/store/mutation-types'
import { mapGetters } from 'vuex'
import _ from 'lodash'

import PackageForm from './PackageForm'

export default {
  name: 'packages',
  components: {PackageForm},
  mixins: [ListMixin],
  data () {
    return {
      showAdd: false,
      loading: true,
      packages: [],
      headers: [
        {
          value: 'name',
          text: 'nazwa',
          sortable: true
        },
        {
          value: 'price',
          text: 'cena',
          sortable: true
        },
        {
          value: 'trainer_name',
          text: 'trener',
          sortable: false
        },
        {
          value: 'is_active',
          text: 'aktywny',
          sortable: true
        },
        {
          value: 'with_tshirt',
          text: 'koszulka',
          sortable: true
        },
        {
          value: 'with_card',
          text: 'karta',
          sortable: true
        },
        {
          value: 'actions',
          text: 'akcje',
          align: 'center',
          sortable: false,
          'class': 'px-0'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['allTrainersOptions'])
  },
  created () {
    this.$store.dispatch(types.ALL_TRAINERS_REQUEST)
  },
  watch: {
    context: {
      handler () {
        this.getPackages()
      },
      deep: true
    }
  },
  methods: {
    formatterBool (data) {
      return boolFormatter(data)
    },
    getPackages () {
      this.loading = true
      let params = this.prepareParams()
      if (this.context.trainer && this.context.trainer !== null) {
        params['trainer'] = this.context.trainer
      }
      let promise = fetchPackages(params)
      return promise.then(this.enhanceListData).then((data) => {
        this.loading = false
        this.packages = data
        return data
      })
    },
    refresh: _.debounce(function () {
      this.getPackages()
    }, 400),
    deleteItem (item) {
      this.$root.$confirm('Usuń pakiet', 'Czy na pewno usunąć pakiet?', {confirmText: 'Usuń', color: 'error'}).then((willDelete) => {
        if (willDelete) {
          let promise = deletePackage(item)
          return promise.then(() => {
            this.refresh()
            iziToast.show({
              message: 'Pakiet został usunięty',
              color: 'green'
            })
          }).catch(() => {
            iziToast.show({
              message: 'Nie udało się usunąć pakietu. Istnieją przypisani do niego zawodnicy.',
              color: 'red'
            })
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/packages/Packages.vue